<foxxylib-component-header [title]="'Vorschlag bearbeiten'" [maticon]="'lightbulb'"></foxxylib-component-header>
@if (vorschlagNichtGefunden()) {
  <div id="vorschlagNichtGefunden" class="p-3 text-red-500">Vorschlag nicht gefunden</div>
}
<p-splitter [style]="{ height: '90%' }" styleClass="mb-8" layout="vertical" [panelSizes]="[75, 25]">
  <ng-template #panel>
    <div class="w-full">
      <div class="grid col-12">
        <div class="col-4">
          <foxxylib-common-bubdata [ean]="ean"></foxxylib-common-bubdata>
          <div class="grid col-12">
            <div class="col-4  "></div>
            <div class="col-8 pl-3">
              @if(this.hauptKategorie())
                {
                <div>Hauptkategorie: &nbsp; {{this.hauptKategorie()}}</div>
              }
              @if(this.wkz())
                {
                <div>WKZ: &nbsp; {{this.wkz()}}</div>
              }
            </div>
          </div>
        </div>
        <div class="col-8">
          <div class="grid">
            <div class="col-12" id="tableabsaetze">
              <p-table [columns]="fisColumns" [value]="fisAbsaetze()" sortMode="none" [paginator]="false" stripedRows
                showGridlines styleClass="">
                <ng-template pTemplate="caption">
                  FIS-Bericht
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    @for (col of columns; track col) {
                      <th [style]="col.style" [pSortableColumn]="col.field">
                        {{col.header}}
                      </th>
                    }
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                  <tr>
                    @for (col of columns; track col) {
                      <td style="text-align: right;">
                        {{ rowData[col.field] | absatzPipe: col }}
                      </td>
                    }
                  </tr>
                </ng-template>
              </p-table>

            </div>



          </div>

          <div class="grid">
            <div class="col ">

              <p-table [columns]="platzierungsColumns" [value]="platzierungen()" sortMode="none" [paginator]="false"
                stripedRows showGridlines styleClass="">
                <ng-template pTemplate="caption">
                  Platzierung
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    @for (col of columns; track col) {
                      <th [style]="col.style" [pSortableColumn]="col.field">
                        {{col.header}}
                      </th>
                    }
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                  <tr>
                    @for (col of columns; track col) {
                      <td [style]="col.style">
                        {{ rowData[col.field].strValue }}
                      </td>
                    }
                  </tr>
                </ng-template>
              </p-table>
            </div>
            <div class="col">

              <p-table [columns]="weitereplatzierungsColumns" [value]="weitereplatzierungenComputed()" sortMode="none"
                [paginator]="false" stripedRows showGridlines styleClass="">
                <ng-template pTemplate="caption">
                  Weitere Platzierungen
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    @for (col of columns; track col) {
                      <th [style]="col.style" [pSortableColumn]="col.field">
                        {{col.header}}
                      </th>
                    }
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                  <tr>
                    @for (col of columns; track col) {
                      <td [style]="col.style">
                        {{ rowData[col.field] }}
                      </td>
                    }
                  </tr>
                </ng-template>
              </p-table>
            </div>

            <div class="col-6"></div>
            <div class="col-6">
              <p-table [columns]="vorschlagstore.filialBestaendColumns()" [value]="vorschlagstore.filialBestaende()"
                sortMode="none" [paginator]="false" stripedRows showGridlines styleClass=" ">
                <ng-template pTemplate="caption">
                  Filialbestand
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    @for (col of columns; track col) {
                      <th [style]="col.style" [pSortableColumn]="col.field">
                        {{col.header}}
                      </th>
                    }
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                  <tr>
                    @for (col of columns; track col) {
                      <td [style]="col.style">
                        {{ rowData[col.field] }}
                      </td>
                    }
                  </tr>
                </ng-template>
              </p-table>
            </div>


          </div>
        </div>
      </div>
    </div>



  </ng-template>
  <ng-template #panel>
    <div class="w-full container">

      <p-toolbar>

        <ng-template #start style="padding-top: 0.5rem;">

          <p-button [label]="'Sortimentieren' " [disabled]="!canSortimentieren()" severity="" size="small"
          styleClass="ml-2" (click)="sortimentieren()"></p-button>

          <p-button [label]="'Entfernen' " [disabled]="!canEntfernen()" size="small" severity="" styleClass="ml-2"
          (click)="entfernen()"></p-button>



          <p-button [label]="'Zurückstellen' " [disabled]="!canZurueckstellen()" size="small" styleClass="ml-2"
          (click)="zurueckstellen()"></p-button>

          <p-float-label variant="on">
            <p-inputNumber id="tage" class="inputTage" min="1" step="1" [(ngModel)]="tagedelay"
              (onBlur)="tagedelayBlur($event)" />
            <label for="tage">Tage zurückstellen</label>
          </p-float-label>






        </ng-template>
        <ng-template #end>
          <p-button icon="pi pi-undo" size="small" severity="warn" [label]="'Abbrechen' " styleClass="ml-2"
          [disabled]="!canCancel()" (click)="cancel()"></p-button>
          <p-button icon="pi pi-times" [label]="'Schließen'" size="small" severity="info" styleClass="ml-2"
          [disabled]="!canClose()" (click)="close()"></p-button>
        </ng-template>
      </p-toolbar>
    </div>

  </ng-template>
</p-splitter>
